// src/components/Admin/Purchases/forms/AddEditPurchaseForm.js
import React, { useState } from "react";
import { Box, Button, Grid, TextField, MenuItem } from "@mui/material";

const DOC_TYPES = [
  { value: "invoice", label: "Factura" },
  { value: "receipt", label: "Boleta" },
  { value: "note", label: "Nota" },
  { value: "other", label: "Otro" },
];
const METHODS = ["transfer","cash","card","deposit","other"];
const CURRENCIES = ["PEN","USD"];

export function AddEditPurchaseForm({ purchase, onSubmit, onClose, onSuccess }) {
  const [form, setForm] = useState({
    supplier: purchase?.supplier || null, // id opcional
    supplier_name: purchase?.supplier_name || "",
    supplier_tax_id: purchase?.supplier_tax_id || "",
    document_type: purchase?.document_type || "invoice",
    invoice_series: purchase?.invoice_series || "",
    invoice_number: purchase?.invoice_number || "",
    issue_date: purchase?.issue_date || new Date().toISOString().slice(0,10),
    due_date: purchase?.due_date || "",
    currency: purchase?.currency || "PEN",
    exchange_rate: purchase?.exchange_rate || 1,
    taxable_amount: purchase?.taxable_amount || "",
    method: purchase?.method || "transfer",
    status: purchase?.status || "recorded",
    notes: purchase?.notes || "",
  });

  const onChange = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    const payload = { ...form, taxable_amount: parseFloat(form.taxable_amount || 0) };
    await onSubmit(payload);
    onSuccess?.();
    onClose?.();
  };

  return (
    <Box component="form" onSubmit={submit}>
      <Grid container spacing={2}>
        <Grid item xs={6}><TextField label="Proveedor ID (opcional)" name="supplier" value={form.supplier || ""} onChange={onChange} fullWidth size="small" /></Grid>
        <Grid item xs={3}><TextField label="Proveedor" name="supplier_name" value={form.supplier_name} onChange={onChange} fullWidth size="small" /></Grid>
        <Grid item xs={3}><TextField label="RUC" name="supplier_tax_id" value={form.supplier_tax_id} onChange={onChange} fullWidth size="small" /></Grid>

        <Grid item xs={4}>
          <TextField select label="Tipo doc." name="document_type" value={form.document_type} onChange={onChange} fullWidth size="small">
            {DOC_TYPES.map(d => <MenuItem key={d.value} value={d.value}>{d.label}</MenuItem>)}
          </TextField>
        </Grid>
        <Grid item xs={4}><TextField label="Serie" name="invoice_series" value={form.invoice_series} onChange={onChange} fullWidth size="small" /></Grid>
        <Grid item xs={4}><TextField label="Número" name="invoice_number" value={form.invoice_number} onChange={onChange} fullWidth size="small" /></Grid>

        <Grid item xs={4}><TextField label="Emisión" type="date" name="issue_date" value={form.issue_date} onChange={onChange} fullWidth size="small" /></Grid>
        <Grid item xs={4}><TextField label="Vencimiento" type="date" name="due_date" value={form.due_date} onChange={onChange} fullWidth size="small" /></Grid>
        <Grid item xs={4}>
          <TextField select label="Moneda" name="currency" value={form.currency} onChange={onChange} fullWidth size="small">
            {CURRENCIES.map(c => <MenuItem key={c} value={c}>{c}</MenuItem>)}
          </TextField>
        </Grid>

        <Grid item xs={4}><TextField label="Tipo de cambio" type="number" name="exchange_rate" value={form.exchange_rate} onChange={onChange} fullWidth size="small" /></Grid>
        <Grid item xs={4}><TextField label="Base imponible" type="number" name="taxable_amount" value={form.taxable_amount} onChange={onChange} fullWidth size="small" required /></Grid>
        <Grid item xs={4}>
          <TextField select label="Método" name="method" value={form.method} onChange={onChange} fullWidth size="small">
            {METHODS.map(m => <MenuItem key={m} value={m}>{m}</MenuItem>)}
          </TextField>
        </Grid>

        <Grid item xs={12}><TextField label="Notas" name="notes" value={form.notes} onChange={onChange} fullWidth size="small" multiline rows={2} /></Grid>
      </Grid>

      <Box mt={2} display="flex" gap={1} justifyContent="flex-end">
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" type="submit">{purchase ? "Guardar" : "Crear"}</Button>
      </Box>
    </Box>
  );
}
